import { Component, OnInit } from '@angular/core';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { ActivatedRoute, Router } from '@angular/router';

import { MessageService } from 'primeng/components/common/messageservice';
import { isNullOrUndefined } from 'util';

import { Gto } from '../base/vo/gto';
import { NovaGto } from '../base/vo/nova-gto';
import { NovaGtoService } from './nova-gto.service';


@Component({
  selector: 'app-nova-gto',
  templateUrl: './nova-gto.component.html',
  styleUrls: ['./nova-gto.component.css'],
})
export class NovaGtoComponent implements OnInit, OnDestroy {
  private sub: any;
  private requestGtoParam: any;

  public abaConsulta = 0;
  public abaPlanos = 0;
  public abaResumo = 0;
  public currentStep = 'consulta';
  public novaGto: NovaGto;
  public loading = false;
  public displayModalErroEnviarGto = false;
  public displayModalProrrogacaoOrtodontia = false;
  public textoModalProrrogacaoOrtodontia = '';
  public numeroGto = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private novaGtoService: NovaGtoService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.novaGto = new NovaGto();
    this.novaGto.primeiraOrtodontia = false;
    this.loading = false;

    this.sub = this.route.fragment.subscribe((f) => {
      this.requestGtoParam = f;
    });

    if (!isNullOrUndefined(this.requestGtoParam)) {
      if (this.requestGtoParam.beneficiario.elegivel === true) {
        // Somente para popular o componente, para uso posterior.
        this.novaGto.beneficiario = this.requestGtoParam.beneficiario;
        this.novaGto.codigoStep = 2;
        this.novaGto.prestExecutante = this.requestGtoParam.prestExecutante;
        this.step(2);
      } else {
        this.step(1);
      }
    } else {
      this.step(1);
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  step(step: number) {
    // 0-next 1-current 2-previous
    if (step == 1) {
      this.abaConsulta = 1;
      this.abaPlanos = 0;
      this.abaResumo = 0;
      this.currentStep = 'consulta';
    } else if (step == 2) {
      this.abaConsulta = 2;
      this.abaPlanos = 1;
      this.abaResumo = 0;
      this.currentStep = 'planos';
    } else if (step == 3) {
      this.abaConsulta = 2;
      this.abaPlanos = 2;
      this.abaResumo = 1;
      this.currentStep = 'resumo';
    }
  }

  recebeNovaGto(novaGto) {
    this.novaGto = novaGto;
    this.step(this.novaGto.codigoStep);
  }

  enviarNovaGto(novaGto) {
    if (!this.loading) {
      this.loading = true;
      this.novaGtoService.emitIsEnviadoGto(true);
      let gto = this.populaGto(novaGto);
      this.novaGtoService.enviarNovaGto(gto).subscribe(
        (response) => {
          this.loading = false;
          this.numeroGto = response.data.numero;

          if (response.data.codigoMensagem == '1') {
            this.displayModalProrrogacaoOrtodontia = true;
            this.textoModalProrrogacaoOrtodontia = response.data.textoMensagem;
          } else {
            this.messageService.add({
              severity: 'success',
              summary: 'Envio de GTO',
              detail: 'A GTO foi enviada com sucesso!',
            });
            this.router.navigate(['detalhagto', this.numeroGto]);
          }
        },
        (error) => {
          this.loading = false;
          this.novaGtoService.emitIsEnviadoGto(false);
          this.displayModalErroEnviarGto = true;
        }
      );
    }
  }

  populaGto(novaGto: NovaGto) {
    let gto = new Gto();
    if (!isNullOrUndefined(novaGto)) {
      gto.codigoBeneficiario = novaGto.beneficiario.codigo;
      gto.telefoneCelContato = novaGto.beneficiario.telefoneCelContato;
      gto.procedimentos = novaGto.listaProcedimentos;
      gto.codigoTipoAtendimento = !isNullOrUndefined(novaGto.tipoAtendimento)
        ? novaGto.tipoAtendimento.id
        : undefined;
      gto.codigoPrestadorExecutante = !isNullOrUndefined(
        novaGto.prestExecutante
      )
        ? novaGto.prestExecutante.codigo
        : undefined;
      gto.observacoesPrestador = novaGto.observacoesTratamento;
      gto.anexos = novaGto.anexos;
      gto.dentistaRadiologia = !isNullOrUndefined(novaGto.dentistaRadiologia)
        ? novaGto.dentistaRadiologia
        : undefined;
      gto.formularioOrtodontia = !isNullOrUndefined(
        novaGto.formularioOrtodontia
      )
        ? novaGto.formularioOrtodontia
        : undefined;
    }
    return gto;
  }

  clickNao() {
    this.displayModalProrrogacaoOrtodontia = false;
    this.router.navigate(['detalhagto', this.numeroGto]);
  }

  clickSim() {
    let novaGtoProrrogacao = new NovaGto();
    novaGtoProrrogacao.codigoStep = 2;
    novaGtoProrrogacao.beneficiario = this.novaGto.beneficiario;
    novaGtoProrrogacao.prestExecutante = this.novaGto.prestExecutante;
    novaGtoProrrogacao.beneficiario.telefoneCelContato =
      this.novaGto.beneficiario.telefoneCelContato;
    novaGtoProrrogacao.prorrogacaoOrtodontia = true;

    this.displayModalProrrogacaoOrtodontia = false;
    this.novaGto = novaGtoProrrogacao;
    this.step(2);
  }

  onClickVoltar() {
    /*
  	if(this.abaConsulta==1) {
  		this.router.navigate(["/dashboard"]);
  	} else if(this.abaPlanos==1) {
  		this.step(1);
  	} else if(this.abaResumo==1) {
  		this.step(2);
  	}
  	*/
    this.router.navigate(['/dashboard']);
  }

  fecharModalErroEnviarGto() {
    this.displayModalErroEnviarGto = false;
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nova-gto/nova-gto.component.ts